// Publicly supported chains today. Solana is intentionally hidden until enabled — add 'solana' here
// (and confirm the Solana/EVM mixing rules) to surface it across the crypto create flow.
export const SUPPORTED_STABLECOIN_CHAINS = ['ethereum', 'base'] as const;

export const STABLECOIN_CHAIN_LABELS: Record<string, string> = {
  ethereum: 'Ethereum',
  base: 'Base',
  solana: 'Solana',
};

// Deprecated aliases count as closed, matching the backend's CryptoPaymentAddressClosedStatuses. Shared
// so the transfer picker and the payment-address table filter deleted addresses out identically.
export const isClosedPaymentAddressStatus = (status: string): boolean => status === 'closed' || status === 'deleted';

// Minimum fiat amount, in cents, matching the API's $1.00 minimum.
export const STABLECOIN_MIN_AMOUNT_CENTS = 100;

export const STABLECOIN_COUNTERPARTY_TYPES = ['person', 'business'] as const;
